export type BankIconMetadata = {
  name: string;
  iconUrl: string;
  aliases: string[];
};

const BANK_ICON_BASE_URL = "https://meritoassets.s3.ap-south-1.amazonaws.com/BankIcons";

export const BANK_ICONS: BankIconMetadata[] = [
  {
    name: "State Bank of India",
    iconUrl: `${BANK_ICON_BASE_URL}/state-bank-of-india.svg`,
    aliases: ["state bank of india", "state bank", "sbi", "sbin"],
  },
  {
    name: "HDFC Bank",
    iconUrl: `${BANK_ICON_BASE_URL}/hdfc-bank.svg`,
    aliases: ["hdfc bank", "hdfc", "hdfc bank limited"],
  },
  {
    name: "ICICI Bank",
    iconUrl: `${BANK_ICON_BASE_URL}/icici-bank.svg`,
    aliases: ["icici bank", "icici", "icic", "icici bank limited"],
  },
  {
    name: "Kotak Mahindra Bank",
    iconUrl: `${BANK_ICON_BASE_URL}/kotak-mahindra-bank.svg`,
    aliases: [
      "kotak mahindra bank",
      "kotak mahindra",
      "kotak bank",
      "kotak",
      "kkbk",
    ],
  },
  {
    name: "Axis Bank",
    iconUrl: `${BANK_ICON_BASE_URL}/axis-bank.svg`,
    aliases: ["axis bank", "axis", "utib"],
  },
  {
    name: "Yes Bank",
    iconUrl: `${BANK_ICON_BASE_URL}/yes-bank.svg`,
    aliases: ["yes bank", "yesbank", "yesb"],
  },
  {
    name: "IndusInd Bank",
    iconUrl: `${BANK_ICON_BASE_URL}/indusind-bank.svg`,
    aliases: ["indusind bank", "indusind", "indb"],
  },
  {
    name: "IDFC First Bank",
    iconUrl: `${BANK_ICON_BASE_URL}/idfc-first-bank.svg`,
    aliases: ["idfc first bank", "idfc bank", "idfc", "idfb"],
  },
  {
    name: "Federal Bank",
    iconUrl: `${BANK_ICON_BASE_URL}/federal-bank.svg`,
    aliases: ["federal bank", "federal", "fdrl"],
  },
  {
    name: "Bank of Baroda",
    iconUrl: `${BANK_ICON_BASE_URL}/bank-of-baroda.svg`,
    aliases: ["bank of baroda", "baroda bank", "bob", "barb"],
  },
  {
    name: "Punjab National Bank",
    iconUrl: `${BANK_ICON_BASE_URL}/punjab-national-bank.svg`,
    aliases: ["punjab national bank", "pnb", "punb"],
  },
  {
    name: "Canara Bank",
    iconUrl: `${BANK_ICON_BASE_URL}/canara-bank.svg`,
    aliases: ["canara bank", "canara", "cnrb"],
  },
  {
    name: "Union Bank of India",
    iconUrl: `${BANK_ICON_BASE_URL}/union-bank-of-india.svg`,
    aliases: ["union bank of india", "union bank", "ubin"],
  },
  {
    name: "Bank of India",
    iconUrl: `${BANK_ICON_BASE_URL}/bank-of-india.svg`,
    aliases: ["bank of india", "boi", "bkid"],
  },
  {
    name: "Indian Bank",
    iconUrl: `${BANK_ICON_BASE_URL}/indian-bank.svg`,
    aliases: ["indian bank", "idib"],
  },
  {
    name: "Central Bank of India",
    iconUrl: `${BANK_ICON_BASE_URL}/central-bank-of-india.svg`,
    aliases: ["central bank of india", "central bank", "cbin"],
  },
  {
    name: "Indian Overseas Bank",
    iconUrl: `${BANK_ICON_BASE_URL}/indian-overseas-bank.svg`,
    aliases: ["indian overseas bank", "iob", "ioba"],
  },
  {
    name: "UCO Bank",
    iconUrl: `${BANK_ICON_BASE_URL}/uco-bank.svg`,
    aliases: ["uco bank", "uco", "ucba"],
  },
  {
    name: "Bank of Maharashtra",
    iconUrl: `${BANK_ICON_BASE_URL}/bank-of-maharashtra.svg`,
    aliases: ["bank of maharashtra", "maharashtra bank", "mahb"],
  },
  {
    name: "Punjab & Sind Bank",
    iconUrl: `${BANK_ICON_BASE_URL}/punjab-and-sind-bank.svg`,
    aliases: ["punjab and sind bank", "punjab & sind bank", "psib"],
  },
  {
    name: "RBL Bank",
    iconUrl: `${BANK_ICON_BASE_URL}/rbl-bank.svg`,
    aliases: ["rbl bank", "rbl", "ratnakar bank", "ratn"],
  },
  {
    name: "Bandhan Bank",
    iconUrl: `${BANK_ICON_BASE_URL}/bandhan-bank.svg`,
    aliases: ["bandhan bank", "bandhan", "bdbl"],
  },
  {
    name: "AU Small Finance Bank",
    iconUrl: `${BANK_ICON_BASE_URL}/au-small-finance-bank.svg`,
    aliases: ["au small finance bank", "au bank", "aubank", "aubk"],
  },
  {
    name: "Equitas Small Finance Bank",
    iconUrl: `${BANK_ICON_BASE_URL}/equitas-small-finance-bank.svg`,
    aliases: ["equitas small finance bank", "equitas bank", "equitas", "esfb"],
  },
  {
    name: "Karur Vysya Bank",
    iconUrl: `${BANK_ICON_BASE_URL}/karur-vysya-bank.svg`,
    aliases: ["karur vysya bank", "karur vysya", "kvb", "kvbl"],
  },
  {
    name: "Tamilnad Mercantile Bank",
    iconUrl: `${BANK_ICON_BASE_URL}/tamilnad-mercantile-bank.svg`,
    aliases: ["tamilnad mercantile bank", "tmb", "tmbl"],
  },
  {
    name: "South Indian Bank",
    iconUrl: `${BANK_ICON_BASE_URL}/south-indian-bank.svg`,
    aliases: ["south indian bank", "sib", "sibl"],
  },
  {
    name: "City Union Bank",
    iconUrl: `${BANK_ICON_BASE_URL}/city-union-bank.svg`,
    aliases: ["city union bank", "cub", "ciub"],
  },
  {
    name: "DBS Bank",
    iconUrl: `${BANK_ICON_BASE_URL}/dbs-bank.svg`,
    aliases: ["dbs bank", "dbs", "dbss", "development bank of singapore"],
  },
  {
    name: "HSBC Bank",
    iconUrl: `${BANK_ICON_BASE_URL}/hsbc-bank.svg`,
    aliases: [
      "hsbc bank",
      "hsbc",
      "hsbc bank india",
      "hk and shanghai banking corporation",
      "hongkong and shanghai banking corporation",
      "hong kong and shanghai banking corporation",
    ],
  },
  {
    name: "Standard Chartered Bank",
    iconUrl: `${BANK_ICON_BASE_URL}/standard-chartered-bank.svg`,
    aliases: [
      "standard chartered bank",
      "standard chartered",
      "scb",
      "scbl",
      "stanchart",
    ],
  },

  // International banks
  {
    name: "ABN AMRO",
    iconUrl: `${BANK_ICON_BASE_URL}/abn-amro-bank.svg`,
    aliases: ["abn amro", "abn", "abnamro"],
  },
  {
    name: "Abu Dhabi Commercial Bank",
    iconUrl: `${BANK_ICON_BASE_URL}/abu-dhabi-commercial-bank.svg`,
    aliases: ["abu dhabi commercial bank", "adcb"],
  },
  {
    name: "American Express",
    iconUrl: `${BANK_ICON_BASE_URL}/american-express.svg`,
    aliases: ["american express", "amex"],
  },
  {
    name: "ANZ",
    iconUrl: `${BANK_ICON_BASE_URL}/anz-bank.svg`,
    aliases: [
      "anz",
      "anz bank",
      "australia and new zealand banking group",
    ],
  },
  {
    name: "Barclays",
    iconUrl: `${BANK_ICON_BASE_URL}/barclays-bank.svg`,
    aliases: ["barclays", "barclays bank"],
  },
  {
    name: "Bank of Bahrain and Kuwait",
    iconUrl: `${BANK_ICON_BASE_URL}/bank-of-bahrain-and-kuwait.svg`,
    aliases: ["bank of bahrain and kuwait", "bbk"],
  },
  {
    name: "BNP Paribas",
    iconUrl: `${BANK_ICON_BASE_URL}/bnp-paribas.svg`,
    aliases: ["bnp paribas", "bnp"],
  },
  {
    name: "Bank of America",
    iconUrl: `${BANK_ICON_BASE_URL}/bank-of-america.svg`,
    aliases: ["bank of america", "bank of america na", "boa", "bofa"],
  },
  {
    name: "Bank of China",
    iconUrl: `${BANK_ICON_BASE_URL}/bank-of-china.svg`,
    aliases: ["bank of china"],
  },
  {
    name: "Crédit Agricole CIB",
    iconUrl: `${BANK_ICON_BASE_URL}/credit-agricole-cib.svg`,
    aliases: ["credit agricole cib", "credit agricole", "cacib"],
  },
  {
    name: "Bank of Ceylon",
    iconUrl: `${BANK_ICON_BASE_URL}/bank-of-ceylon.svg`,
    aliases: ["bank of ceylon", "ceylon bank"],
  },
  {
    name: "JPMorgan Chase",
    iconUrl: `${BANK_ICON_BASE_URL}/jpmorgan-chase.svg`,
    aliases: [
      "jpmorgan chase",
      "jp morgan chase",
      "jpmorgan",
      "jp morgan",
      "chase bank",
      "chase",
    ],
  },
  {
    name: "Citibank",
    iconUrl: `${BANK_ICON_BASE_URL}/citibank.svg`,
    aliases: ["citibank", "citi bank", "citi"],
  },
  {
    name: "Commonwealth Bank",
    iconUrl: `${BANK_ICON_BASE_URL}/commonwealth-bank.svg`,
    aliases: [
      "commonwealth bank",
      "commonwealth bank of australia",
      "commbank",
      "cba",
    ],
  },
  {
    name: "Credit Suisse",
    iconUrl: `${BANK_ICON_BASE_URL}/credit-suisse.svg`,
    aliases: ["credit suisse", "creditsuisse"],
  },
  {
    name: "Deutsche Bank",
    iconUrl: `${BANK_ICON_BASE_URL}/deutsche-bank.svg`,
    aliases: ["deutsche bank", "deutsche"],
  },
  {
    name: "Doha Bank",
    iconUrl: `${BANK_ICON_BASE_URL}/doha-bank.svg`,
    aliases: ["doha bank", "doha"],
  },
  {
    name: "Emirates NBD",
    iconUrl: `${BANK_ICON_BASE_URL}/emirates-nbd.svg`,
    aliases: ["emirates nbd", "emiratesnbd", "enbd"],
  },
  {
    name: "First Abu Dhabi Bank",
    iconUrl: `${BANK_ICON_BASE_URL}/first-abu-dhabi-bank.svg`,
    aliases: ["first abu dhabi bank", "first abu dhabi", "fab"],
  },
  {
    name: "FirstRand Bank",
    iconUrl: `${BANK_ICON_BASE_URL}/firstrand-bank.svg`,
    aliases: ["firstrand bank", "first rand bank", "firstrand"],
  },
  {
    name: "Hana Bank",
    iconUrl: `${BANK_ICON_BASE_URL}/hana-bank.svg`,
    aliases: ["hana bank", "keb hana bank", "hana"],
  },
  {
    name: "Handelsbanken",
    iconUrl: `${BANK_ICON_BASE_URL}/handelsbanken.svg`,
    aliases: ["handelsbanken", "svenska handelsbanken"],
  },
  {
    name: "Industrial and Commercial Bank of China",
    iconUrl: `${BANK_ICON_BASE_URL}/industrial-and-commercial-bank-of-china.svg`,
    aliases: [
      "industrial and commercial bank of china",
      "industrial commercial bank of china",
      "icbc",
    ],
  },
  {
    name: "KB Kookmin Bank",
    iconUrl: `${BANK_ICON_BASE_URL}/kb-kookmin-bank.svg`,
    aliases: ["kb kookmin bank", "kookmin bank", "kookmin", "kb bank"],
  },
  {
    name: "Bank of Korea",
    iconUrl: `${BANK_ICON_BASE_URL}/bank-of-korea.svg`,
    aliases: ["bank of korea", "korea bank"],
  },
  {
    name: "Krung Thai Bank",
    iconUrl: `${BANK_ICON_BASE_URL}/krung-thai-bank.svg`,
    aliases: ["krung thai bank", "krungthai bank", "krungthai", "ktb"],
  },
  {
    name: "Maybank",
    iconUrl: `${BANK_ICON_BASE_URL}/maybank.svg`,
    aliases: ["maybank", "malayan banking", "malayan banking berhad"],
  },
  {
    name: "Mizuho Bank",
    iconUrl: `${BANK_ICON_BASE_URL}/mizuho-bank.svg`,
    aliases: ["mizuho bank", "mizuho"],
  },
  {
    name: "MUFG Bank",
    iconUrl: `${BANK_ICON_BASE_URL}/mufg-bank.svg`,
    aliases: [
      "mufg bank",
      "mufg",
      "mitsubishi ufj",
      "mitsubishi ufj financial group",
      "bank of tokyo mitsubishi ufj",
    ],
  },
  {
    name: "National Australia Bank",
    iconUrl: `${BANK_ICON_BASE_URL}/national-australia-bank.svg`,
    aliases: ["national australia bank", "nab"],
  },
  {
    name: "NatWest",
    iconUrl: `${BANK_ICON_BASE_URL}/natwest.svg`,
    aliases: ["natwest", "natwest bank", "national westminster bank"],
  },
  {
    name: "OCBC Bank",
    iconUrl: `${BANK_ICON_BASE_URL}/ocbc-bank.svg`,
    aliases: ["ocbc bank", "ocbc", "oversea chinese banking corporation"],
  },
  {
    name: "Qatar National Bank",
    iconUrl: `${BANK_ICON_BASE_URL}/qatar-national-bank.svg`,
    aliases: ["qatar national bank", "qnb"],
  },
  {
    name: "Rabobank",
    iconUrl: `${BANK_ICON_BASE_URL}/rabobank.svg`,
    aliases: ["rabobank", "rabo bank"],
  },
  {
    name: "Royal Bank of Canada",
    iconUrl: `${BANK_ICON_BASE_URL}/royal-bank-of-canada.svg`,
    aliases: ["royal bank of canada", "rbc", "rbc royal bank"],
  },
  {
    name: "Saxo Bank",
    iconUrl: `${BANK_ICON_BASE_URL}/saxo-bank.svg`,
    aliases: ["saxo bank", "saxo"],
  },
  {
    name: "Sberbank",
    iconUrl: `${BANK_ICON_BASE_URL}/sberbank.svg`,
    aliases: ["sberbank", "sber bank", "sber"],
  },
  {
    name: "Scotiabank",
    iconUrl: `${BANK_ICON_BASE_URL}/scotiabank.svg`,
    aliases: ["scotiabank", "scotia bank", "bank of nova scotia"],
  },
  {
    name: "Shinhan Bank",
    iconUrl: `${BANK_ICON_BASE_URL}/shinhan-bank.svg`,
    aliases: ["shinhan bank", "shinhan"],
  },
  {
    name: "Sumitomo Mitsui Banking Corporation",
    iconUrl: `${BANK_ICON_BASE_URL}/sumitomo-mitsui-banking-corporation.svg`,
    aliases: [
      "sumitomo mitsui banking corporation",
      "sumitomo mitsui bank",
      "smbc",
    ],
  },
  {
    name: "Société Générale",
    iconUrl: `${BANK_ICON_BASE_URL}/societe-generale.svg`,
    aliases: ["societe generale", "société générale", "socgen"],
  },
  {
    name: "Sonali Bank",
    iconUrl: `${BANK_ICON_BASE_URL}/sonali-bank.svg`,
    aliases: ["sonali bank", "sonali"],
  },
  {
    name: "TD Bank",
    iconUrl: `${BANK_ICON_BASE_URL}/td-bank.svg`,
    aliases: ["td bank", "toronto dominion bank", "toronto dominion", "td"],
  },
  {
    name: "UBS",
    iconUrl: `${BANK_ICON_BASE_URL}/ubs.svg`,
    aliases: ["ubs", "ubs bank"],
  },
  {
    name: "United Overseas Bank",
    iconUrl: `${BANK_ICON_BASE_URL}/united-overseas-bank.svg`,
    aliases: ["united overseas bank", "uob", "uob bank"],
  },
  {
    name: "Wells Fargo",
    iconUrl: `${BANK_ICON_BASE_URL}/wells-fargo.svg`,
    aliases: ["wells fargo", "wells fargo bank", "wells"],
  },
  {
    name: "Westpac",
    iconUrl: `${BANK_ICON_BASE_URL}/westpac.svg`,
    aliases: [
      "westpac",
      "westpac bank",
      "westpac banking corporation",
    ],
  },
  {
    name: "Woori Bank",
    iconUrl: `${BANK_ICON_BASE_URL}/woori-bank.svg`,
    aliases: ["woori bank", "woori"],
  },
];

const GENERIC_ALIAS_VALUES = [
  "bank",
  "india",
  "indian",
  "national",
  "payments",
  "payment",
  "small finance",
  "finance",
  "limited",
  "ltd",
  "current account",
  "savings account",
  "account",
];

const normalizeBankName = (value: string) =>
  value
    .toLowerCase()
    .trim()
    .replace(/&/g, "and")
    .replace(/[^a-z0-9]/g, "");

const GENERIC_ALIASES = new Set(
  GENERIC_ALIAS_VALUES.map((alias) => normalizeBankName(alias))
);

const BANK_ALIAS_MAP = new Map<string, BankIconMetadata>();

BANK_ICONS.forEach((bank) => {
  bank.aliases.forEach((alias) => {
    const normalizedAlias = normalizeBankName(alias);
    if (!normalizedAlias || GENERIC_ALIASES.has(normalizedAlias)) return;
    BANK_ALIAS_MAP.set(normalizedAlias, bank);
  });
});

const RESOLVED_BANK_CACHE = new Map<string, BankIconMetadata | null>();

export function getBankMetadata(bankName: string): BankIconMetadata | null {
  const input = normalizeBankName(bankName);
  if (!input) return null;

  const exactMatch = BANK_ALIAS_MAP.get(input);
  if (exactMatch) return exactMatch;

  if (RESOLVED_BANK_CACHE.has(input)) {
    return RESOLVED_BANK_CACHE.get(input) ?? null;
  }

  let bestMatch: BankIconMetadata | null = null;
  let longestAliasLength = 0;

  for (const [alias, bank] of BANK_ALIAS_MAP) {
    if (input.includes(alias) && alias.length > longestAliasLength) {
      bestMatch = bank;
      longestAliasLength = alias.length;
    }
  }

  RESOLVED_BANK_CACHE.set(input, bestMatch);
  return bestMatch;
}

export function getBankIcon(bankName: string): string | null {
  return getBankMetadata(bankName)?.iconUrl ?? null;
}
